import { render, staticRenderFns } from "./bindingList.vue?vue&type=template&id=39c234b7&scoped=true"
import script from "./bindingList.vue?vue&type=script&lang=js"
export * from "./bindingList.vue?vue&type=script&lang=js"
import style0 from "./bindingList.vue?vue&type=style&index=0&id=39c234b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c234b7",
  null
  
)

export default component.exports